import { Box, Typography, Avatar } from '@mui/material';
import { School, Verified } from '@mui/icons-material';
import gatewayLogo from '../../assets/GatewayLogo/imageGateway.png';
import './EnhancedCertificateBadge.css';

const EnhancedCertificateBadge = ({ 
  certificateName, 
  badgeColor = '#010910',
  size = 'medium'
}) => {
  return (
    <Box className={`enhancedCertificateBadge size-${size}`} style={{ '--badge-color': badgeColor }}>
      <Box className="gradientBorder" />
      <Avatar
        className="badgeAvatar"
        sx={{
          backgroundImage: `url(${gatewayLogo})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <Box className="badgeContent">
          <School className="schoolIcon"  />
          <Typography variant="caption" className="certificateText">
            {certificateName}
          </Typography>
        </Box>
      </Avatar>
  
      <Box className="verifiedIndicator">
        <Verified className="verifiedIcon" />
      </Box>
    </Box>
  );
};

export default EnhancedCertificateBadge;
